import async from 'async';

angular.module("SupportAgent")
.controller(
 'SupportShowController',
 ['$rootScope', '$scope', '$routeParams', '$location', 'EventHandler','$timeout','$mdDialog','$sce',
  'U','L','INTERACT','INTRACTABLE','IDA',
 function ($rootScope, $scope, $routeParams, $location, EventHandler,$timeout,$mdDialog,$sce,
   U,L,INTERACT,INTRACTABLE,IDA) {
 $scope.name = "support";

 $scope.have_create_account = !$rootScope.isHidden('create_account');

 $scope.msgfilter = function msgfilterer(s) {
  return function msg_filter(m) {
   return m && m.msg && !(s && m.msg.indexOf(s)<0);
  };
 };

 
 function navigate() {

  var oconvo = $rootScope.selected_conversation;
  var convid = $rootScope.conversationID = (+$routeParams.cid)||undefined;
  var convo = $rootScope.selected_conversation = $rootScope.conversationID && INTERACT.get_conversation($rootScope.conversationID);
  $rootScope.conversation_is_mine = convo && convo.is_mine();
  if(convo) $rootScope.$broadcast('wtg.conversation.selected',{newconvo:convo,oldconvo:oconvo});

  var acid = $rootScope.accountID = (+$routeParams.aid)||undefined;
  var account = $rootScope.selected_account = INTERACT.get_account($rootScope.accountID);
  if(account && convo)
   account.dcid = convo.id;

  $rootScope.showProviderInfo=false;
  $rootScope.enableLiveResultsControl = false;
  $scope.enable_create_ticket_btn=!($rootScope.selected_account&&$rootScope.selected_account.has_open_conversations());
  $rootScope.stopDeviceStatusCheck();
  $rootScope.diagnose_ticket = convo;
  if($rootScope.virtualConnection) EventHandler.APILAYER.closeVirtualConnection($rootScope.virtualConnection.cid);
  $rootScope.messageTypes = [{type:"Chat",str:$rootScope.strings.str_msg_type_chat},{type:"Terminal",str:$rootScope.strings.str_msg_type_terminal},
  {type:"Push Notification",str:$rootScope.strings.str_msg_type_push_notification}];
  $rootScope.turned_off_tests={};
  if(acid) {
   /* TODO: the condition below should only be temporary, it's actually is a
    * weird situation where we have an account selected, but it doesn't exist
    * */
   if(account) account.load_conversations(function(e) {
    if(e) return L.error({err:e,account:account},"error loading conversation for the account");
   });
   if(convid) {
    if(!convo) L.error({cid:convid},"navigating to unknown conversation");
    else convo.reset_unreads();
   }else{
    L.error("just want to know when we land here in the normal flows");
    var newconvo = account.get_conversations()[0];
    if(newconvo) $location.path('/support/'+acid+'/'+newconvo.id);
   }
  }

  // To select the device, which was previously selected, on the account connected to current conversation
  if(account && account.sd >=0 ) {
   $rootScope.selectDevice(account.sd);
  }
  else $scope.showDeviceLoadingString = true;

  if(convo) convo.msg_count = 0;

  if(!(account && INTRACTABLE.has_token())) return;
  INTRACTABLE.request("devices",
   {"_AID": acid},
   function(e, r) {
    if(e) return L.error({err:e},"failed to fetch user devices");
    if(r._S!='ok') return L.error({r:r},"failed to fetch user devices");
    account.tr = [];
    var d = account.d = EventHandler.prepareDevices(r.devices.reverse());
    var seldev = 0;
    if(r.last_used_device) {
     var i = d.findIndex(function(x){return x.id==r.last_used_device});
     if(i<0) L.warn({r:r,acid:acid},"last used device is not even a device!");
     else seldev = i;
    }
    if(seldev!=account.sd) $rootScope.selectDevice(seldev);
    $scope.$applyAsync(function() {
     $scope.showDeviceLoadingString = false;
    });
   }
  );
  account.get_profile(function(e) {
   if(e) return L.error({err:e},"error loading profile");
   $rootScope.$broadcast('wtg.conversations');
  });
 }//navigate()
 navigate();

 $scope.$on('wtg.xxx.loaded-conversations',navigate);
 // TODO: this is not the best fix for updating controls on takeover stealing
 // the ticket, until the component makes sense.
 $scope.$on('wtg.interact.conversation.change',function on_interact_conversation_change(evt,args) {
  if($rootScope.selected_conversation && args.convid==$rootScope.selected_conversation.id
     && args.change=='leave' && args.acid==INTERACT.get_myself().id)
   navigate();
 });

 $scope.$on('$routeChangeSuccess',function(evt,current) {
  if(current.scope.name=='support') navigate();
 });
 $scope.$on('$routeUpdate',function(evt,current) {
  if(current.scope.name=='support') navigate();
 });

 $scope.takeover = function(convo) {
  $mdDialog.show(
   $mdDialog.confirm()
    .textContent(WTG.fmt($rootScope.strings.str_takeover_warning,{ticketid:convo.id,agent:convo.get_agent_name()}))
    .ok($rootScope.strings.str_yes)
    .cancel($rootScope.strings.str_no)
   ).then(function() {
   /* TODO: this `series` means that otherwise we won't know one response from
    * the other. But this is not a guarantee, either… */
    async.series([
    (cb)=> {
     convo.request_add_participant(INTERACT.get_myself(),(e,r)=>{
      if(!(e && e.rc==2 /* TODO: magic */)) return cb(e,r);
      /* TODO: this is somewhat unpretty, but as far as I can tell by the
       * WTGServer code, this error most likely means that the participant is
       * already participating in the conversation and therefore can not be
       * added. We need to findout why this happens, but as it is, let's just
       * try ignoring the fact. */
      L.error({err:e,r:r,convo:{id:convo.id,p:convo.p}},"we seem to be entering the conversation we're already in");
      cb(null);
     });
    },
    convo.request_remove_participant.bind(convo,convo.get_agent())
   ],function(e) {
    if(e) return L.error({err:e},"failed to take over the conversation");
    navigate();
    $rootScope.$broadcast('wtg.interact.conversations');
   });
  },function() {
   L.trace("not attempting to take over the conversation");
  });
 };

 if($rootScope.isSearchPanelActive===undefined)
  $rootScope.isSearchPanelActive=true;
 $scope.onChangeCreatePanel = function(p) {
  $rootScope.isSearchPanelActive=p;
 };

 $scope.changeSubmitResultEventOnDevice = function(r) {
  EventHandler.APILAYER.sendMessage({
    convid: $rootScope.conversationID, channelid: INTERACT.D.xaction.channel.diagreq,
    msg: "8|"+r.id,// TODO: magic
    devid: $rootScope.deviceID });
 };


 $rootScope.getAccountID = function (conid) {
  var c = INTERACT.get_conversation(+conid);
  return c && c.get_supportee().id;
 };
 $scope.create_new_ticket = function(acid) {
  INTERACT.get_account(acid).create_conversation({},function(e,r) {
   if(e) return L.error({err:e},"failed to create conversation");
   $location.path('/support/'+acid+'/'+r.convid);
  });
 };
 $scope.closeTicket=function() {
  $mdDialog.show({
   clickOutsideToClose: true,
   templateUrl: 'snippets/dialogs/agent-feedback.html',
   scope: $scope.$new(false),
   controllerAs: 'ctrl',
   controller: function($scope,$mdDialog) {

    this.rhelp = this.rhappy = 0;
    this.comment="";
    this.complaint = this.complaint_other = this.identify = this.solve = this.cause = '';
    $scope.complaints = [
     'str_feedback_complaint_slow',
     'str_feedback_complaint_not_work',
     'str_feedback_complaint_trouble',
     'str_other'
    ];
    $scope.stars = [1,2,3,4,5];


    var that = this;
    $scope.af_submit = function() {
     $scope.busybee=true;
     INTRACTABLE.request("feedback/support", {
      CID: $rootScope.conversationID,
      complaint: that.complaint_other||that.complaint,
      identified: that.identify, solved: that.solve,
      cause: that.cause,
      help: that.rhelp, happy: that.rhappy,
      comment:that.comment
     },function(e,r) {
      if(e||r._S!='ok') return L.error({e:e,r:r},"failed to submit feedback"),$mdDialog.hide('error');
      $mdDialog.hide('submit');
     });
    };
    $scope.af_skip = function() {
     $mdDialog.hide('skip');
    };
   }
  }).then(function(/*outcome*/) {
   // TODO: handle 'error' outcome somehow?
   $scope.changeSubmitResultEventOnDevice($rootScope.submit_results.find(function(r) { return r.id==INTERACT.D.xaction.live_diagnostics_states.off}));
   $scope.change_conversation_status($rootScope.selected_conversation,
    INTERACT.D.conversation.status.closed);
  },function() {
  });
 };
 $scope.openAgentCommentField=function() {
  /* TODO: we should make sure we are able to do IDA at this point, but not by
   * copypasting idiotic code with alert in it… */
  $mdDialog.show({
   clickOutsideToClose: true,
   templateUrl: 'snippets/dialogs/agent-comment.html',
   scope: $scope.$new(false),
   controllerAs: 'ctrl',
   controller: function($scope,$mdDialog,$sce) {
    var url= IDA.get_url('ticket-form',{convid:$rootScope.conversationID});
    $scope.ticket_form_url= $sce.trustAsResourceUrl(url);
   }
  });
 };
 $scope.change_conversation_status = function(c,status) {
  var convid = c.id;
  // TODO: while I think I preserved the logic of the original code, I'm sure it must be faulty.
  EventHandler.APILAYER.changeSupportStatus({convid,status});
  // TODO: are we entitled to assume the api call above succeded here?
  c.update({status});
  if(c.is_alive()) return;
  var stee = c.get_supportee();
  var cc = stee.get_conversations().find(function(x) { return x.is_alive() });
  if(cc) return $location.path('/support/'+stee.id+'/'+cc.id);
  EventHandler.stopLiveDataConnection($rootScope.preConversationID); // TODO: what the hell is that?!
 };
 $scope.$on('wtg.conversations',function on_wtg_conversations() {
  $scope.enable_create_ticket_btn=!($rootScope.selected_account&&$rootScope.selected_account.has_open_conversations());
 });
 $scope.$on('wtg.interact.conversation.change',function(evt,args) {
  if(!(args.change=='leave'&&args.acid==INTERACT.get_myself().id)) return;
  const convo = INTERACT.get_conversation(args.convid);
  $mdDialog.show(
   $mdDialog.alert()
    .textContent(WTG.fmt($rootScope.strings.str_takeover_owner_alert,{ticketid:convo.id,agent:convo.get_agent_name()}))
    .ok($rootScope.strings.ok_btn)
  );
 });
}]);
/* vim:set ts=8 sw=1 expandtab: */
